import { walls } from '../data/walls';
import { locationColours } from '../data/locationColours';

export const wallData = (id) => {
  let index = walls.findIndex( x => parseInt(x.id) === parseInt(id) );
  return walls[ index ];
};

export const wallLocations = (id, locations) => {
  return locations.nodes.filter(location => parseInt(location.node.wall_number) === parseInt(id));
};

export const locationColour = (id, locations) => {
  let index = locations.nodes.findIndex( x => parseInt(x.node.nid) === parseInt(id) );
  return locationColours[ index ];
};